import { Injectable, Signal, signal } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class RouteService {
    private _currentRoute = signal<string>('')
    private _previousRoute = signal<string>('')
    private _parentRoute = signal<string>('')
    private _data = signal<Record<string, string>>({})

    public getCurrentRoute(): Signal<string> {
        return this._currentRoute
    }

    public setCurrentRoute(value: string): void {
        this._currentRoute.set(value)
    }

    public previousRoute(): Signal<string> {
        return this._previousRoute
    }

    public setPreviousRoute(value: string): void {
        this._previousRoute.set(value)
    }

    public parentRoute(): Signal<string> {
        return this._parentRoute
    }

    public setParentRoute(value: string): void {
        this._parentRoute.set(value)
    }

    public getData(): Signal<Record<string, string>> {
        return this._data
    }

    public setData(value: Record<string, string>): void {
        this._data.set(value)
    }
}
